export default __webpack_public_path__ + "cfcb106a0eaa31a096d38be2a65ad449.png";